import { Event, SDK, ServerOptions } from '@commercetools/frontend-sdk';
import { ProjectSettings, ArtifiSettings } from 'shared/types/projectSettings/ProjectSettings';
import { callActionMiddleware } from '@/helpers/utils/callActionHelper';
import { GetProjectSettingsAction, GetArtifiSettingsAction } from '../../types/actions/ProjectActions';
import { ComposableCommerceEvents } from '../../types/events/ComposableCommerceEvents';

export type ProjectActions = {
  getSettings: GetProjectSettingsAction;
  getArtifiSettings: GetArtifiSettingsAction;
};

export const getProjectActions = (sdk: SDK<ComposableCommerceEvents>): ProjectActions => {
  return {
    getSettings: async (options: { serverOptions?: ServerOptions } = {}) => {
      const response = await callActionMiddleware<ProjectSettings>({
        actionName: 'project/getProjectSettings',
        serverOptions: options.serverOptions,
      });

      if (response.isError === false) {
        sdk.trigger(
          new Event({
            eventName: 'projectSettingsFetched',
            data: {
              projectSettings: response.data,
            },
          }),
        );
      }
      return response;
    },
    getArtifiSettings: async (options: { serverOptions?: ServerOptions } = {}) => {
      const response = await callActionMiddleware<ArtifiSettings>({
        actionName: 'project/getArtifiSettings',
        serverOptions: options.serverOptions,
      });

      if (response.isError === false) {
        sdk.trigger(
          new Event({
            eventName: 'getArtifiSettings',
            data: {
              artifiSettings: response.data,
            },
          }),
        );
      }
      return response;
    },
  };
};
